const ENDPOINT = {
  ssoLogin: 'sso/adminLogin',
  plantList: 'plantList',
  createUser: 'UserCreate',
  getUserRole: 'getUserRole',
  getUserList: 'getUserList',
  deleteUser: 'deleteUser',
  updateUser: 'updateUser',
  getUserid: 'getUserid',
  subTaskQues: 'subTaskQues',
  updateSubQues: 'updateSubQues',
  updateVLM: 'updateVLM',
  uploadFAQ: 'uploadFAQ',
  uploadBulkUser: 'uploadBulkUser',
  sectionWeightage: 'section-weightage',
  plantManagement: 'plantManagement',
  addPlant: 'addPlant'
}

export default ENDPOINT;